import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { AssessmentSessionForStatsDateResponse } from '../../models/session.types';

interface SessionListProps {
  session?: AssessmentSessionForStatsDateResponse;
  selectedExamSheetId?: string;
  onChange: (event: SelectChangeEvent<string>) => void;
}

export const ExamSheetsList: React.FC<SessionListProps> = ({ session, selectedExamSheetId, onChange }) => {
  const isNoExamSheet = session && session?.examSheets.length === 0;

  return (
    <>
      <FormControl
        style={{ width: '370px', position: 'relative', top: '55px', right: '55px', textAlign: 'left' }}
        size="small"
      >
        <InputLabel>Wybierz arkusz</InputLabel>
        <Select
          variant="outlined"
          label="Wybierz arkusz"
          placeholder='"Wybierz arkusz'
          value={selectedExamSheetId ?? ''}
          onChange={isNoExamSheet ? undefined : onChange}
          inputProps={{
            color: '#000000',
            padding: '5px',
          }}
        >
          {session &&
            session?.examSheets.map((examSheet) => (
              <MenuItem disableRipple key={examSheet.examSheetId} value={examSheet.examSheetId}>
                Arkusz:&nbsp;
                <span>
                  <b>{examSheet.sheetCode}</b>
                </span>
              </MenuItem>
            ))}
          {isNoExamSheet && (
            <MenuItem disabled disableRipple key="Brak arkuszy" value="">
              <span>Brak arkuszy</span>
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </>
  );
};
